"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ExternalPricingAPI = void 0;
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _NextApiClient = require("./NextApiClient");
var ExternalPricingAPI = /*#__PURE__*/function () {
  function ExternalPricingAPI() {
    (0, _classCallCheck2["default"])(this, ExternalPricingAPI);
  }
  (0, _createClass2["default"])(ExternalPricingAPI, null, [{
    key: "purchaseConditionsUpdate",
    value: function purchaseConditionsUpdate(data) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      _NextApiClient.NextApiClient.com(this.service, 'jPurchaseConditionsUpdate', {
        json: (0, _stringify["default"])(data)
      }, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "getPurchaseConditions",
    value: function getPurchaseConditions(catalog, numberOfEntries, startFrom, extraData) {
      var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function (j) {
        console.error(j);
      };
      _NextApiClient.NextApiClient.com(this.service, 'jGetPurchaseConditions', {
        catalog: catalog,
        numberOfEntries: numberOfEntries,
        startFrom: startFrom,
        extraData: extraData
      }, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "salesIndexUpdate",
    value: function salesIndexUpdate(data) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      _NextApiClient.NextApiClient.com(this.service, 'jSalesIndexUpdate', {
        json: (0, _stringify["default"])(data)
      }, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "getSalesIndex",
    value: function getSalesIndex(catalog, numberOfEntries, startFrom, extraData) {
      var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function (j) {
        console.error(j);
      };
      _NextApiClient.NextApiClient.com(this.service, 'jGetSalesIndex', {
        catalog: catalog,
        numberOfEntries: numberOfEntries,
        startFrom: startFrom,
        extraData: extraData
      }, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "vatRateUpdate",
    value: function vatRateUpdate(data) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      _NextApiClient.NextApiClient.com(this.service, 'jVATRateUpdate', {
        json: (0, _stringify["default"])(data)
      }, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "getVATRates",
    value: function getVATRates(catalog, numberOfEntries, startFrom, extraData) {
      var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function (j) {
        console.error(j);
      };
      _NextApiClient.NextApiClient.com(this.service, 'jGetVATRates', {
        catalog: catalog,
        numberOfEntries: numberOfEntries,
        startFrom: startFrom,
        extraData: extraData
      }, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "getCalcGroups",
    value: function getCalcGroups(catalog, extraData) {
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.error(j);
      };
      _NextApiClient.NextApiClient.com(this.service, 'jGetCalculationGroupsList', {
        catalog: catalog,
        extraData: extraData
      }, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "getItemGroups",
    value: function getItemGroups(catalog, extraData) {
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.error(j);
      };
      _NextApiClient.NextApiClient.com(this.service, 'jGetItemGroupsList', {
        catalog: catalog,
        extraData: extraData
      }, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "setExtraShopCatalogData",
    value: function setExtraShopCatalogData(catalog, extraData) {
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.error(j);
      };
      _NextApiClient.NextApiClient.com(this.service, 'jSetExtraShopCatalogData', {
        catalogName: catalog,
        json: (0, _stringify["default"])(extraData)
      }, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "getExtraShopCatalogData",
    value: function getExtraShopCatalogData(catalog, extraData) {
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.error(j);
      };
      _NextApiClient.NextApiClient.com(this.service, 'jGetExtraShopCatalogData', {
        catalogName: catalog,
        extraData: extraData ? (0, _stringify["default"])(extraData) : extraData
      }, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }]);
  return ExternalPricingAPI;
}();
exports.ExternalPricingAPI = ExternalPricingAPI;
ExternalPricingAPI.service = 'externalPricing';
//# sourceMappingURL=ExternalPricingAPI.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/api/ExternalPricingAPI.js
// module id = 1238
// module chunks = 142